'use client'
import { motion } from 'framer-motion'
const Closing = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-16">
      <motion.h4
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center md:text-left"
      >
        O Propósito em Comum
      </motion.h4>

      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.2 }}
        viewport={{ once: true }}
        className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed text-center md:text-left"
      >
        Com trajetórias complementares e experiências internacionais, Barbara e
        Thamiris uniram suas expertises para fundar a{" "}
        <span className="font-semibold text-gray-900">escapa!</span>. A startup
        nasceu para transformar a forma como empresas e profissionais do turismo
        inovam, utilizando inteligência artificial, pesquisa aplicada e
        criatividade para criar experiências sensoriais e memoráveis.
      </motion.p>
    </div>
  );
};

export default Closing;
